import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import {
  connectAutocomplete,
  connectSearchBox,
} from 'instantsearch.js/es/connectors';

import { renderAutocomplete } from '@/src/utilities/search/searchRenderFunctions';

export function loadConditionLandingSearch(): void {
  const config = window['condition-landing-search'];

  if (!config) {
    return;
  }

  const { searchIndexName, applicationId, searchKey } = config;

  const algoliaClient = algoliasearch(applicationId, searchKey);

  const searchClient = {
    ...algoliaClient,
    search(requests: any[]) {
      return algoliaClient.search(requests);
    },
  };

  const search = instantsearch({
    indexName: searchIndexName,
    searchClient,
    insights: true,
  });

  const virtualSearchBox = connectSearchBox(() => null);
  const customAutocomplete = connectAutocomplete(renderAutocomplete);

  search.addWidgets([
    customAutocomplete({
      container: document.querySelector('[data-app-search-box]'),
    }),

    virtualSearchBox({}),
  ]);

  search.start();

  // error handler to prevent uncaught errors
  search.on('error', () => {
    console.log('error', search.error);
  });

  search.on('render', () => {
    console.log('search status:', search.status);
    console.log('error', search.status === 'error' && search.error);
  });
}
